// extracted by mini-css-extract-plugin
export default {"container":"AutoCarousel_container__myYXI","slider":"AutoCarousel_slider__VtmIr","slide":"AutoCarousel_slide__YWRBY"};